module.exports = __webpack_public_path__ + "static/img/login-list-icon-naver.bdd46b46.svg";